import React from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import SearchIcon from '@mui/icons-material/Search';

const selectSx = {
  height: '40px',
  borderRadius: '8px',
  fontSize: '0.875rem',
  minWidth: 170,
  backgroundColor: '#fff',
  '& .MuiOutlinedInput-notchedOutline': { borderColor: '#E0E0E0' },
  '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#BDBDBD' },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: 'primary.main' },
};

const textSx = {
  '& .MuiOutlinedInput-root': {
    borderRadius: '8px',
    backgroundColor: '#fff',
    height: '40px',
    '& fieldset': { borderColor: '#E0E0E0' },
    '&:hover fieldset': { borderColor: '#BDBDBD' },
    '&.Mui-focused fieldset': { borderColor: 'primary.main' },
  },
  '& input': { fontSize: '0.875rem' },
};

const STATUS_OPTIONS = [
  { value: 'all', label: 'Todos os status' },
  { value: 'pending', label: 'Pendente' },
  { value: 'expired', label: 'Expirado' },
  { value: 'confirmed', label: 'Confirmado' },
];

/**
 * SignupFilters - Barra de filtros da tela "Cadastros pendentes" (Admin Geral)
 * @param {Object} props
 * @param {string} props.status
 * @param {Function} props.onStatusChange
 * @param {string} props.searchInput
 * @param {Function} props.onSearchInputChange
 */
function SignupFilters({ status, onStatusChange, searchInput, onSearchInputChange }) {
  return (
    <Box
      sx={{
        p: 2,
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        flexWrap: 'wrap',
        borderBottom: '1px solid #E8ECF0',
        bgcolor: '#fff',
      }}
    >
      <TextField
        size="small"
        placeholder="Buscar por nome, e-mail, empresa ou telefone"
        value={searchInput}
        onChange={(e) => onSearchInputChange(e.target.value)}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon sx={{ color: 'text.disabled', fontSize: 18 }} />
            </InputAdornment>
          ),
        }}
        sx={{ flex: 1, minWidth: 240, maxWidth: { sm: 380 }, ...textSx }}
      />

      <Select size="small" value={status} onChange={(e) => onStatusChange(e.target.value)} sx={selectSx}>
        {STATUS_OPTIONS.map((opt) => (
          <MenuItem key={opt.value} value={opt.value}>{opt.label}</MenuItem>
        ))}
      </Select>
    </Box>
  );
}

export default SignupFilters;
